import FieldPhoneNumber from 'shared/Forms/Fields/PhoneNumber/FieldPhoneNumber';
import InputLandlinePhone from 'shared/Forms/Inputs/PhoneNumber/InputLandlinePhone';
import InputPhoneNumber from 'shared/Forms/Inputs/PhoneNumber/InputPhoneNumber';
import React from 'react';

export default class FieldLandlinePhone extends React.Component {
	render() {
		return (
			<FieldPhoneNumber
				className={this.props.className}
				disabled={this.props.disabled}
				labelClass={this.props.labelClass}
				name={this.props.name}
				required={this.props.required}
				inputClass={this.props.inputClass}
				type="landline"
			/>
		);
	}
}

FieldLandlinePhone.defaultProps = {
	autocomplete: InputPhoneNumber.defaultProps.autocomplete,
	className: InputPhoneNumber.defaultProps.className,
	disabled: InputPhoneNumber.defaultProps.disabled,
	inputClass: InputPhoneNumber.defaultProps.className,
	labelClass: FieldPhoneNumber.defaultProps.labelClass,
	name: InputLandlinePhone.defaultProps.name,
	required: InputPhoneNumber.defaultProps.required,
};
